import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { BuyerThresholdCheck, IRFQSupplierQuotation } from 'src/app/modules/pr-buyer/models';
import { PrBuyerHelperService } from 'src/app/modules/pr-buyer/services/pr-buyer-helper.service';
import { PrInitiatorService } from 'src/app/modules/pr-initiator/services/pr-initiator.service';
import { ILineItemDetail } from 'src/app/modules/shared/models/purchase-order.model';
@Component({
  selector: 'accept-counter-offer',
  templateUrl: './accept-counter-offer.component.html',
  styleUrls: ['./accept-counter-offer.component.scss']
})
export class AcceptCounterOfferComponent implements OnInit {

  public title !: string;
  public onClose = new BehaviorSubject<any>({});

  public lineNumberQuotationMap !: any;
  public buyerThresholdCheck !: BuyerThresholdCheck;
  public prId !: string;
  public freightLineItems:any;

  constructor(public bsModalRef: BsModalRef, private _router : Router, private prInitiatorService:PrInitiatorService,
    private _buyerHelperService: PrBuyerHelperService) { }

  ngOnInit(): void {
    console.log(this.buyerThresholdCheck);
    this.prInitiatorService.fetchPrForPreview(this.prId).subscribe((res:any)=>{
      if(res.data){
        this.freightLineItems = res.data[0].line_items.filter((lineItem:any)=>lineItem.line_item_status == "FRIEGHT APPROVED");
        if(this.freightLineItems.length){
          const lineItemNumber = this.freightLineItems[0]?.line_item_number;
          const quotation = {
            user_name: this.freightLineItems[0]?.vendor_name,
            tax: 0,
            line_item_number: lineItemNumber,
            quantity: this.freightLineItems[0]?.quantity,
            final_price: this.freightLineItems[0]?.price,
            total_price: this.freightLineItems[0]?.quantity * this.freightLineItems[0]?.price
          }
          this.lineNumberQuotationMap = {...this.lineNumberQuotationMap,...quotation};
        }
        console.log(this.lineNumberQuotationMap)
      }
    })
  }

  public acceptCounterOffer() : void {
    // if(this.buyerThresholdCheck?.divisionDetails?.managerApprovalRequired){
    //   this._buyerHelperService.openManagerApprovalModal()?.subscribe((res:any)=>{
        
    //   })
    // }else{
    //   this._router.navigate([`buyer/quality-evaluation-sheet/${this.prId}`])
    // }
    this.onModalClose();
  }

  public onModalClose(): void {
    this.bsModalRef.hide();
  }

  public closeModal() {
    this.onClose.next({value:true});
    this.bsModalRef.hide();
  }

}
